export default {
    bind(el, binding, vnode){
        const dom = el instanceof HTMLInputElement ? el : el.querySelector('input')
        dom.onblur = function(){
            dom.value = dom.value.trim()
            dom.dispatchEvent(new Event('input'))
        }
    }
}